export const institutions = [
    [
    {
        "Institution_Code": 2018201234205,
        "Institution_Name": "SHIPCODE & TRADING CO. LTD",
        "Prefix": "CSA"
    },
    {
        "Institution_Code": 2018201234230,
        "Institution_Name": "NAARA RURAL BANK",
        "Prefix": "NRB"
    },
    {
        "Institution_Code": 2018201234299,
        "Institution_Name": "ENVIRON. PROTECT. AGENCY",
        "Prefix": "EPA"
    },
    {
        "Institution_Code": 2018201234330,
        "Institution_Name": "ODOTOBRI RURAL BANK",
        "Prefix": "ORB"
    },
    {
        "Institution_Code": 2018201234333,
        "Institution_Name": "GRIDCO",
        "Prefix": "GRIDCO"
    },
    {
        "Institution_Code": 2018201234335,
        "Institution_Name": "WA COMMUNITY CREDIT UNION",
        "Prefix": "CCU"
    },
    {
        "Institution_Code": 2018201234337,
        "Institution_Name": "AMANTIN & KASEI COM BANK"
    },
    {
        "Institution_Code": 2018201234339,
        "Institution_Name": "GHANA WATER - ACCRA EAST",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234341,
        "Institution_Name": "FUNDAMENTAL BAPTIST CH.",
        "Prefix": "WL"
    },
    {
        "Institution_Code": 2018201234343,
        "Institution_Name": "GHANA TEXTILES PRINTING",
        "Prefix": "GTP"
    },
    {
        "Institution_Code": 2018201234344,
        "Institution_Name": "SAFEBOND GHANA LTD.",
        "Prefix": "SAFEBOND"
    },
    {
        "Institution_Code": 2018201234345,
        "Institution_Name": "PENT PRIM SCH BUBUASHIE",
        "Prefix": "PPJ"
    },
    {
        "Institution_Code": 2018201234348,
        "Institution_Name": "BONZALI RURAL BANK",
        "Prefix": "BRB"
    },
    {
        "Institution_Code": 2018201234355,
        "Institution_Name": "GHANA WATER - PRODUCTION",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234445,
        "Institution_Name": "CAPITAL BANK"
    },
    {
        "Institution_Code": 2018201234468,
        "Institution_Name": "SSNIT- ACCRA",
        "Prefix": "SSNIT"
    },
    {
        "Institution_Code": 2018201234476,
        "Institution_Name": "GH. CIVIL AVIATION AUTH.",
        "Prefix": "GCAA"
    },
    {
        "Institution_Code": 2018201234518,
        "Institution_Name": "JUABENG RURAL BANK"
    },
    {
        "Institution_Code": 2018201234527,
        "Institution_Name": "ASUOGYAMAN RURAL BANK"
    },
    {
        "Institution_Code": 2018201234529,
        "Institution_Name": "GHANA WATER CO. LTD-K'DUA",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234530,
        "Institution_Name": "ANUM RURAL BANK",
        "Prefix": "ANUM"
    },
    {
        "Institution_Code": 2018201234535,
        "Institution_Name": "P.S.C. TEMA SHIPYARD LTD",
        "Prefix": "PSC"
    },
    {
        "Institution_Code": 2018201234539,
        "Institution_Name": "GHANA-RE COMPANY LTD",
        "Prefix": "GRC"
    },
    {
        "Institution_Code": 2018201234573,
        "Institution_Name": "KOMFO ANOKYE HOSPITAL",
        "Prefix": "ESP"
    },
    {
        "Institution_Code": 2018201234583,
        "Institution_Name": "NEXANS KABELMETAL",
        "Prefix": "NEXANS"
    },
    {
        "Institution_Code": 2018201234635,
        "Institution_Name": "CARMEUSE LIME",
        "Prefix": "CLP"
    },
    {
        "Institution_Code": 2018201234639,
        "Institution_Name": "COCOA PROCESSING CO. LTD.",
        "Prefix": "CPC"
    },
    {
        "Institution_Code": 2018201234640,
        "Institution_Name": "UNIVERSITY OF DEVT STDS.",
        "Prefix": "UDS"
    },
    {
        "Institution_Code": 2018201234642,
        "Institution_Name": "UNIVERSITY OF EDUCATION",
        "Prefix": "UEW"
    },
    {
        "Institution_Code": 2018201234664,
        "Institution_Name": "GHANA WATER COMP-SUNYANI",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234666,
        "Institution_Name": "GHANA WATER COMP. -TDI",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234681,
        "Institution_Name": "GHANA WATER CO. LTD -K'SI",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234682,
        "Institution_Name": "GHANA WATER CO. LTD -HO",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234702,
        "Institution_Name": "ELECTRICITY COMPANY OF GHANA",
        "Prefix": "ECG"
    },
    {
        "Institution_Code": 2018201234705,
        "Institution_Name": "NATIONAL INSURANCE COMM.",
        "Prefix": "NIC"
    },
    {
        "Institution_Code": 2018201234706,
        "Institution_Name": "STARLIFE ASSURANCE CO.",
        "Prefix": "SL"
    },
    {
        "Institution_Code": 2018201234707,
        "Institution_Name": "NEW TIMES CORPORATION",
        "Prefix": "NTC"
    },
    {
        "Institution_Code": 2018201234708,
        "Institution_Name": "STANDARD CHARTERD BANK"
    },
    {
        "Institution_Code": 2018201234711,
        "Institution_Name": "PRODUCE BUYING COMPANY",
        "Prefix": "PBC"
    },
    {
        "Institution_Code": 2018201234715,
        "Institution_Name": "GHANA WATER-ACCRA WEST",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234723,
        "Institution_Name": "G.I.M.P.A",
        "Prefix": "GIMPA"
    },
    {
        "Institution_Code": 2018201234733,
        "Institution_Name": "GHANA WATER-WA",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234734,
        "Institution_Name": "UNIVERSITY OF CAPECOAST",
        "Prefix": "UCC"
    },
    {
        "Institution_Code": 2018201234736,
        "Institution_Name": "GHANA RAILWAY COMPANY",
        "Prefix": "GRC"
    },
    {
        "Institution_Code": 2018201234738,
        "Institution_Name": "SOS GHANA",
        "Prefix": "SOS"
    },
    {
        "Institution_Code": 2018201234741,
        "Institution_Name": "CHRISTIAN FAITH CHURCH",
        "Prefix": "CFC"
    },
    {
        "Institution_Code": 2018201234742,
        "Institution_Name": "TEMA DEVELOPMENT CORP.",
        "Prefix": "TDC"
    },
    {
        "Institution_Code": 2018201234745,
        "Institution_Name": "TEMA PARENT ASS. SCHOOL",
        "Prefix": "TPA"
    },
    {
        "Institution_Code": 2018201234749,
        "Institution_Name": "LATEX FOAM CO. LTD.",
        "Prefix": "LATEX"
    },
    {
        "Institution_Code": 2018201234757,
        "Institution_Name": "VALLEY VIEW UNIVERSITY",
        "Prefix": "VVU"
    },
    {
        "Institution_Code": 2018201234758,
        "Institution_Name": "GHANA WATER -C/R",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234760,
        "Institution_Name": "GHANA WATER - TAMALE",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201234779,
        "Institution_Name": "STAR ASSURANCE COMP. LTD.",
        "Prefix": "SO"
    },
    {
        "Institution_Code": 2018201234780,
        "Institution_Name": "BUREAU OF NATIONAL INV.",
        "Prefix": "BNI"
    },
    {
        "Institution_Code": 2018201234781,
        "Institution_Name": "WAEC",
        "Prefix": "WAEC"
    },
    {
        "Institution_Code": 2018201234786,
        "Institution_Name": "K NKRUMAH UNIVERSITY",
        "Prefix": "KNUST"
    },
    {
        "Institution_Code": 2018201234787,
        "Institution_Name": "MINISTRY OF NATIONAL SECURITY",
        "Prefix": "NATSEC"
    },
    {
        "Institution_Code": 2018201234788,
        "Institution_Name": "VOLTA RIVER AUTHORITY",
        "Prefix": "VRA"
    },
    {
        "Institution_Code": 2018201234789,
        "Institution_Name": "GHANA AIRPORT CO. LTD.",
        "Prefix": "GA"
    },
    {
        "Institution_Code": 2018201234790,
        "Institution_Name": "GHANA POST COMPANY LTD",
        "Prefix": "GPO"
    },
    {
        "Institution_Code": 2018201234791,
        "Institution_Name": "SAMARTEX",
        "Prefix": "SAMA"
    },
    {
        "Institution_Code": 2018201234792,
        "Institution_Name": "GHANA COCOA BOARD",
        "Prefix": "COCOBOD"
    },
    {
        "Institution_Code": 2018201234805,
        "Institution_Name": "CONTROLLER"
    },
    {
        "Institution_Code": 2018201234821,
        "Institution_Name": "GHANA POLICE SERVICE",
        "Prefix": "GPS"
    },
    {
        "Institution_Code": 2018201234822,
        "Institution_Name": "MINISTRY OF DEFENCE",
        "Prefix": "MOD"
    },
    {
        "Institution_Code": 2018201234827,
        "Institution_Name": "GHANA PORTS & HABOURS",
        "Prefix": "GPHA"
    },
    {
        "Institution_Code": 2018201234833,
        "Institution_Name": "UNIVERSITY OF GHANA LEGON",
        "Prefix": "UG"
    },
    {
        "Institution_Code": 2018201234845,
        "Institution_Name": "KUMAWUMAN RURAL BANK"
    },
    {
        "Institution_Code": 2018201234846,
        "Institution_Name": "ASOKORE RURAL BANK"
    },
    {
        "Institution_Code": 2018201234852,
        "Institution_Name": "NWABIAGYA RURAL BANK"
    },
    {
        "Institution_Code": 2018201234856,
        "Institution_Name": "KINTAMPO RURAL BANK"
    },
    {
        "Institution_Code": 2018201234919,
        "Institution_Name": "UPPER M. KROBO RURAL BANK"
    },
    {
        "Institution_Code": 2018201234925,
        "Institution_Name": "MULTI CREDIT"
    },
    {
        "Institution_Code": 2018201234933,
        "Institution_Name": "AHANTAMAN RURAL BANK"
    },
    {
        "Institution_Code": 2018201234934,
        "Institution_Name": "FIASEMAN RURAL BANK"
    },
    {
        "Institution_Code": 2018201234939,
        "Institution_Name": "AMENFIMAN RURAL BANK"
    },
    {
        "Institution_Code": 2018201234940,
        "Institution_Name": "KAKUM RURAL BANK"
    },
    {
        "Institution_Code": 2018201234941,
        "Institution_Name": "WETO RURAL BANK"
    },
    {
        "Institution_Code": 2018201234965,
        "Institution_Name": "AMANSIE RURAL BANK"
    },
    {
        "Institution_Code": 2018201240713,
        "Institution_Name": "GHANA WATER - HEAD OFFICE",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201240714,
        "Institution_Name": "GHANA WATER -KUMASI SOUTH",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2018201240716,
        "Institution_Name": "SEWERAGE SYSTEMS GHANA LT",
        "Prefix": "SSG"
    },
    {
        "Institution_Code": 2018201241053,
        "Institution_Name": "MANYA KROBO RURAL BANK LTD"
    },
    {
        "Institution_Code": 2018201241072,
        "Institution_Name": "SONZELE RURAL BANK LTD"
    },
    {
        "Institution_Code": 2018201241078,
        "Institution_Name": "UPPER AMENFI RURAL BANK LTD"
    },
    {
        "Institution_Code": 2019201241305,
        "Institution_Name": "UTRACK SAVINGS AND LOANS"
    },
    {
        "Institution_Code": 2019201241421,
        "Institution_Name": "PARLIAMENT HOUSE GHANA",
        "Prefix": "S"
    },
    {
        "Institution_Code": 2019201241586,
        "Institution_Name": "UNIVERSITY OF ENERGY AND NATURAL RESOURCES",
        "Prefix": "PSM"
    },
    {
        "Institution_Code": 2019201241597,
        "Institution_Name": "FIESTA ROYALE HOTEL",
        "Prefix": "FRH"
    },
    {
        "Institution_Code": 2019201241876,
        "Institution_Name": "SEED PRODUCTION DIVISION",
        "Prefix": "SPD"
    },
    {
        "Institution_Code": 2019201242059,
        "Institution_Name": "GHANA REVENUE AUTHORITY",
        "Prefix": "GRA"
    },
    {
        "Institution_Code": 2020201242288,
        "Institution_Name": "COMPASSION GHANA-SUNYANI",
        "Prefix": "CS"
    },
    {
        "Institution_Code": 2020201242538,
        "Institution_Name": "OPPORTUNITY S&L STAFF",
        "Prefix": "OSL"
    },
    {
        "Institution_Code": 2020201242667,
        "Institution_Name": "GHANA WATER-UPPER EAST",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2020201242719,
        "Institution_Name": "GHANA WATER - BOTTLING PLANT",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2020201242751,
        "Institution_Name": "GHANA WATER-TEMA",
        "Prefix": "GWCL"
    },
    {
        "Institution_Code": 2022201244453,
        "Institution_Name": "COMMUNITY WATER AND SANITATION AGENCY",
        "Prefix": "CWSA"
    },
    {
        "Institution_Code": 2022201244583,
        "Institution_Name": "GHANA OIL PLANTATION DEV'T LTD",
        "Prefix": "GOPDC"
    },
    {
        "Institution_Code": 2023201245999,
        "Institution_Name": "THE APOSTOLIC CHURCH, GHANA",
        "Prefix": "TM"
    },
    {
        "Institution_Code": 2024201246392,
        "Institution_Name": "REDPEAR COMMUNICATIONS COMPANY LTD",
        "Prefix": "RPC"
    }
]
]